"use client";
import React from "react";

import { Box } from "../../foundations";
import { Button } from "../Button";
import { TextField, TextFieldProps } from "../TextField/TextField";

export interface SearchBarProps extends Omit<TextFieldProps, "search"> {
  onClickSearch?: () => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  onClickSearch,
  disabled,
  ...props
}) => {
  const searchIcon = React.useCallback(
    () => (
      <Button
        icon="magnifying-glass"
        aria-label="Search"
        disabled={disabled}
        onClick={onClickSearch}
      />
    ),
    [disabled, onClickSearch]
  );

  return (
    <Box sx={{ position: "relative" }}>
      <TextField
        searchIcon={searchIcon}
        onEnter={onClickSearch}
        disabled={disabled}
        {...props}
      />
    </Box>
  );
};
